import React        from 'react';
import { FaUserCircle }  from 'react-icons/fa';
import { MdEmail }       from 'react-icons/md';
import { IoDocumentText } from 'react-icons/io5';

import ProfileRow   from './ProfileRow';
import logoPng      from '../../assets/truscan_logo.png';
import './ProfilePage.scss';

export default function ProfilePage() {
  const noop = () => alert('Coming soon!');

  return (
    <div className="profile-page">
      {/* ─── Top bar ─── */}
      <header className="top-bar">
        <img src={logoPng} alt="logo" className="logo" />
        <FaUserCircle className="avatar" />
      </header>

      {/* ─── Centered rows ─── */}
      <div className="rows">
        <ProfileRow
          icon={<MdEmail />}
          label="Contact Support"
          onClick={noop}
        />
        <ProfileRow
          icon={<IoDocumentText />}
          label="Regulations"
          onClick={noop}
        />
      </div>

      {/* footer */}
      <footer className="version">TRUscan.AI  v1.0</footer>
    </div>
  );
}
